module.exports = {"511425102":"汉阳镇","511425105":"河坝子镇","511425106":"南城镇","511425107":"青城镇","511425108":"瑞峰镇","511425109":"黑龙镇","511425110":"西龙镇","511425205":"高台乡","511425217":"白果乡","511425218":"罗波乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511425.json
// module id = 2171
// module chunks = 0